import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
const FAQ_GROUPS: {
  group: string;
  items: {
    q: string;
    a: string;
  }[];
}[] = [{
  group: 'Orders',
  items: [{
    q: 'How long until my order ships?',
    a: 'Orders placed before 2pm ET ship the same business day. Everything else ships within 1–2 business days, and you get a tracking link by email as soon as the label is created.'
  }, {
    q: 'Can I change or cancel my order?',
    a: 'If your order has not shipped yet, email us and we will update or cancel it. Once tracking is live, treat it as a return instead.'
  }, {
    q: 'Do you ship outside the US?',
    a: 'Not yet. We currently ship within the United States, including Alaska and Hawaii. International shipping is on the roadmap.'
  }]
}, {
  group: 'Products',
  items: [{
    q: 'Are your supplements third-party tested?',
    a: 'Yes. Every batch is tested by an independent lab for identity, potency, heavy metals, and microbials before it reaches the store.'
  }, {
    q: 'Do you use proprietary blends?',
    a: 'No. Every active ingredient is listed with its exact dose so you can compare it against the published research.'
  }, {
    q: 'Can I take multiple products together?',
    a: 'Most of the catalog is designed to stack — protein, creatine, and electrolytes are commonly taken together. Check with your physician if you take prescription medication.'
  }]
}, {
  group: 'Returns & payment',
  items: [{
    q: 'What is the return window?',
    a: '30 days from delivery, opened or unopened. See Shipping & Returns for how to start one.'
  }, {
    q: 'What payment methods do you accept?',
    a: 'All major credit and debit cards, Apple Pay, and Google Pay, processed securely by Stripe. We never see or store your card details.'
  }, {
    q: 'Do I need an account to order?',
    a: 'No. You can check out as a guest. Creating an account just saves your order history and makes reordering faster.'
  }]
}];
export function Faq() {
  return <div className="w-full min-h-screen bg-white" data-id="element-2452" data-mp="2820dcgtplz1u">
      <section className="pt-32 md:pt-36 pb-12 md:pb-16 px-6" data-id="element-2453" data-mp="2d14o3bwa84ua">
        <div className="max-w-3xl mx-auto" data-id="element-2454" data-mp="2czjsrk258hvd">
          <div className="text-sm text-[#5A5A5A] mb-6" data-id="element-2455" data-mp="1z1lsfiknqlyv">
            <Link to="/" className="hover:text-tealslate transition-colors underline decoration-[#E5E5E5] underline-offset-4" data-id="element-2456" data-mp="1z47zzi7jt1h3">
              Home
            </Link>{' '}
            <span className="mx-2" data-id="element-2457" data-mp="1u2sexq5deuyp">/</span> FAQ
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-[#1F1F1F] mb-4 tracking-tight" data-id="element-2458" data-mp="1u3ah13eps3ej">
            Frequently asked questions
          </h1>
          <p className="text-base text-[#5A5A5A]" data-id="element-2459" data-mp="3ogjiq910qkm8">
            Shipping, ingredients, returns, and payment — answered. Still stuck?{' '}
            <Link to="/contact" className="font-bold text-[#1F1F1F] hover:text-tealslate transition-colors underline underline-offset-2" data-id="element-2460" data-mp="1cu7y0epmlznv">
              Contact support
            </Link>
            .
          </p>
        </div>
      </section>

      <section className="pb-20 md:pb-28 px-6" data-id="element-2461" data-mp="1hs9jt7efsd31">
        <div className="max-w-3xl mx-auto space-y-12" data-id="element-2462" data-mp="1hqgb7mk9jise">
          {FAQ_GROUPS.map(group => <div key={group.group} data-id="element-2463" data-mp="1vm0r094p3kvl">
              <h2 className="text-[11px] font-bold text-tealslate uppercase tracking-[0.25em] mb-5" data-id="element-2464" data-mp="1rivrmffwvzb6">
                {group.group}
              </h2>
              <div className="border-t border-[#E5E5E5]" data-id="element-2465" data-mp="25hc6wuruay4x">
                {group.items.map(item => <details key={item.q} className="group border-b border-[#E5E5E5]" data-id="element-2466" data-mp="20gxxb8albg4s">
                    <summary className="cursor-pointer list-none flex items-center justify-between gap-6 py-5 text-base font-bold text-[#1F1F1F]" data-id="element-2467" data-mp="65jaaz8yrusq">
                      {item.q}
                      <ChevronDown className="w-4 h-4 shrink-0 text-[#9A9A90] transition-transform duration-200 ease-out group-open:rotate-180" data-id="element-2468" data-mp="cl9p6ck268zb" />
                    </summary>
                    <p className="text-sm text-[#5A5A5A] leading-relaxed pb-5 max-w-2xl" data-id="element-2469" data-mp="hi9qyb9vkpkm">
                      {item.a}
                    </p>
                  </details>)}
              </div>
            </div>)}
        </div>
      </section>

      <section className="bg-[#F9F9F9] py-16 md:py-20 px-6 border-t border-[#E5E5E5]" data-id="element-2470" data-mp="3q0xt2kyyhrwo">
        <div className="max-w-2xl mx-auto text-center" data-id="element-2471" data-mp="3uy7s8sc5dhxp">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1F1F1F] tracking-tight mb-3" data-id="element-2472" data-mp="3uxejxmxjikdg">
            Still have a question?
          </h2>
          <p className="text-base text-[#5A5A5A] mb-8" data-id="element-2473" data-mp="329ioeljpiyi9">
            Send us the details and we'll reply within one business day.
          </p>
          <Link to="/contact" className="inline-flex px-7 py-3.5 bg-[#1F1F1F] text-white text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#3B3B3B] transition-colors rounded" data-id="element-2474" data-mp="377k4cxlu6hpi">
            Contact Support
          </Link>
        </div>
      </section>
    </div>;
}